import { userRole } from '@const/userRoles';

export function user(state) {
  return state.user;
}

export function locale(state) {
  return state.user.lang;
}

export function userEmail(state) {
  return state.user.email;
}

export function isAdmin(state) {
  return state.user.roles.some((r) => r.name === userRole.SUPERADMIN);
}

export function isAdminOrStaff(state) {
  return state.user.roles.some((r) => [
    userRole.SUPERADMIN,
    userRole.STAFF,
  ].includes(r.name));
}

export function hasWebAccess(state) {
  return state.user.roles.some((r) => [
    userRole.SUPERADMIN,
    userRole.STAFF,
    userRole.PROVIDER,
    userRole.FACILITY,
  ].includes(r.name));
}

export function userHasRole(state) {
  return (role) => state.user.roles.find((r) => r.name === role);
}

export function isLoggedIn(state) {
  return state.user.token !== null;
}

export function userHasTemporaryPassword(state) {
  return !!state.user.is_temp_password;
}

export function todayTasks(state) {
  return state.todayTasks;
}

export function todayTasksCount(state) {
  return state.todayTasksCount;
}

export function listTypes(state) {
  return state.listTypes;
}

export function drawerOpen(state) {
  return state.drawerOpen;
}

export function lastCaseType(state) {
  return state.lastCaseType;
}
